import {
  createPlugin,
  createRoutableExtension,
  createApiFactory,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { DamCapabilityApiRef } from './api/DamCapabilityApi';
import { DamCapabilityClient } from './api/DamCapabilityClient';
import { rootRouteRef } from './routes';

export const DamCapabilityPlugin = createPlugin({
  id: 'dam-capability',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: DamCapabilityApiRef,
      deps: { discoveryApi: discoveryApiRef, identityApi: identityApiRef },
      factory: ({ discoveryApi, identityApi }) =>
        new DamCapabilityClient({ discoveryApi, identityApi }),
    }),
  ],
});

export const DamCapabilityPage = DamCapabilityPlugin.provide(
  createRoutableExtension({
    name: 'UserPage',
    component: () => import('./components/MainPage').then(m => m.MainPage),
    mountPoint: rootRouteRef,
  }),
);
